import React from 'react';

export default function Logo({ size = 34 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="512" height="512" rx="42.7" fill="#000060" />
      <polygon points="85.3,113.8 170.7,113.8 256.0,369.8 199.1,369.8" fill="white" />
      <polygon points="341.3,113.8 426.7,113.8 256.0,369.8 298.7,369.8" fill="white" />
      <polygon points="213.3,241.8 312.9,113.8 426.7,113.8 298.7,369.8 256.0,369.8" fill="#D4AF37" />
    </svg>
  );
}
